import React, { useEffect } from "react";
import { Typography, Box, Link } from "@mui/material";
import { useLocation } from "react-router-dom";
import ContactChat from "../Hellper/ContactChat";
import Logo from "../Images/Footer/15.jpg";
import Track from "../Images/8.jpg";
import EmailIcon from "@mui/icons-material/Email";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
function AboutUs() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <div>
      <Box
        sx={{
          padding: "20px",
          maxWidth: "1100px",
          margin: "auto",
          marginTop: "60px",
          "@media (min-width: 1024px)": {
            marginTop: "80px",
          },
        }}
      >
        {/* About Us Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: "#1e3a8a",
            fontSize: "1.5rem",
            fontWeight: "bold",
            "@media (min-width: 1024px)": {
              fontSize: "1.75rem",
            },
          }}
        >
          About Us
        </Typography>

        <Typography
          variant="body1"
          paragraph
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          <strong>UK TO MARS LTD</strong> is a dynamic UK-based export and
          wholesale distribution company specialising in fast-moving consumer
          goods (FMCG) Based in Buckingham, we connect the UK to global markets.
        </Typography>

        {/* Who We Are Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: "#1e3a8a",
            fontSize: "1.5rem",
            fontWeight: "bold",
            "@media (min-width: 1024px)": {
              fontSize: "1.75rem",
            },
          }}
        >
          Who We Are
        </Typography>

        <Typography
          variant="body1"
          paragraph
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          We support retailers, wholesalers, and distributors worldwide by
          providing access to a wide range of top-tier products from the UK, Our
          portfolio includes trusted brands in confectionery, beverages,
          personal care, baby products, household items, and more—all offered at
          competitive B2B prices.
        </Typography>

        {/* What We Do Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: "#1e3a8a",
            fontSize: "1.5rem",
            fontWeight: "bold",
            "@media (min-width: 1024px)": {
              fontSize: "1.75rem",
            },
          }}
        >
          What We Do
        </Typography>

        <Typography
          variant="body1"
          paragraph
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          We deliver a complete export and logistics service tailored for global
          trade:
        </Typography>

        <Box
          component="ul"
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            pl: 2,
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          {[
            {
              title: "Product Sourcing & Wholesale",
              description:
                "A broad, regularly updated range of FMCG goods sourced from trusted UK suppliers.",
            },
            {
              title: "Export Documentation & Compliance",
              description:
                "We manage all regulatory and customs paperwork—making global trade smooth and hassle-free.",
            },
          ].map((item, index) => (
            <React.Fragment key={index}>
              <li>
                <strong>{item.title}</strong>
              </li>
              <Typography component="div">{item.description}</Typography>
            </React.Fragment>
          ))}
        </Box>

        {/* Why Choose Us Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: "#1e3a8a",
            fontSize: "1.5rem",
            fontWeight: "bold",
            "@media (min-width: 1024px)": {
              fontSize: "1.75rem",
            },
          }}
        >
          Why Choose UK TO MARS LTD?
        </Typography>

        <Box
          component="ul"
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            pl: 2,
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          {[
            "Competitive wholesale pricing",
            "Mixed pallets & low MOQs",
            "Expertise in UK and international logistics",
            "Fully compliant & VAT registered",
            "Transparent, customer-focused service",
          ].map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </Box>

        {/* Our Mission Section */}
        <Typography
          variant="h5"
          gutterBottom
          sx={{
            color: "#1e3a8a",
            fontSize: "1.5rem",
            fontWeight: "bold",
            "@media (min-width: 1024px)": {
              fontSize: "1.75rem",
            },
          }}
        >
          Our Mission
        </Typography>

        <Typography
          variant="body1"
          paragraph
          sx={{
            color: "#1D1616",
            fontSize: "1.1rem",
            "@media (min-width: 1024px)": {
              fontSize: "1.2rem",
            },
          }}
        >
          To bridge the gap between UK/EU suppliers and global buyers—offering
          reliable, cost-effective, and efficient solutions for international
          trade.
        </Typography>

        {/* Company Info Section */}
        {/* Company Info Section with Image */}
        <Box
          sx={{
            mt: 6,
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            alignItems: "center",
            gap: 4,
          }}
        >
          {/* Company Info Text - Left Side */}
          <Box
            sx={{
              textAlign: "left",
              flex: 1,
              order: { xs: 2, md: 1 },
            }}
          >
            {/* Logo Image - Centered Below */}
            <Box
              sx={{
                display: "flex",

                mt: 4,
                mb: 4,
              }}
            >
              <img
                src={Logo}
                height={66}
                width={220}
                style={{
                  borderRadius: "20%",
                }}
                alt="UK TO MARS Logo"
              />
            </Box>
            <Typography
              variant="h6"
              paragraph
              sx={{
                color: "#1e3a8a",
                fontSize: "1.3rem",
                fontWeight: "bold",
              }}
            >
              <strong>UK TO MARS LTD</strong>
              <br />
              Wholesaler-Exporter
              <br />
              International Transportation
            </Typography>

            <Typography
              variant="body1"
              paragraph
              sx={{
                color: "#1D1616",
                fontSize: "1.1rem",
                "@media (min-width: 1024px)": {
                  fontSize: "1.2rem",
                },
              }}
            >
              Address: 15 Little Balmer, Buckingham Industrial Estate,
              Buckingham, MK18 1TF, United Kingdom.
              <br />
              Company Registration No: 15764998
              <br />
              VAT No: GB473487946
              <br />
              EORI number: GB473487946000
              <br />
              Emails:
              <br />
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:info@uktomars.co.uk"
                  color="inherit"
                  underline="hover"
                >
                  info@uktomars.co.uk
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:sales@uktomars.co.uk"
                  color="inherit"
                  underline="hover"
                >
                  sales@uktomars.co.uk
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <EmailIcon fontSize="small" />
                <Link
                  href="mailto:admin@uktomars.co.uk"
                  color="inherit"
                  underline="hover"
                >
                  admin@uktomars.co.uk
                </Link>
              </Box>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <WhatsAppIcon fontSize="small" />
                <Link
                  href="https://wa.me/447564627910"
                  target="_blank"
                  rel="noopener noreferrer"
                  color="inherit"
                  underline="hover"
                >
                  +44 7564 627910
                </Link>
              </Box>
            </Typography>
          </Box>

          {/* Tracking Image - Right Side */}
          <Box
            sx={{
              flex: 1,
              order: { xs: 1, md: 2 },
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <img
              src={Track}
              alt="Transportation Tracking"
              style={{
                maxWidth: "100%",
                height: "auto",
                borderRadius: "8px",
                boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              }}
            />
          </Box>
        </Box>
      </Box>
      <ContactChat />
    </div>
  );
}

export default AboutUs;
